import React, { Fragment } from 'react';

import MUIDataTable from "mui-datatables";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import NumberFormat from 'react-number-format';
import Notification from '../Notifications';
import { CashBalanceApi } from '../../api/cash_balance_api'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import FormGroup from '@material-ui/core/FormGroup';
import { ThemeProvider } from "@material-ui/styles";
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search'
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import DateFnsUtils from '@date-io/date-fns';
import 'date-fns';
import esLocale from "date-fns/locale/es";
import moment from 'moment';
import { muitheme } from '../../theme/muiTheme'
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    DatePicker,
} from '@material-ui/pickers';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import * as userActionCreators from '../../actions/user';


function mapDispatchToProps(dispatch) {
    return bindActionCreators(userActionCreators, dispatch);
}

function mapStateToProps(state) {
    return {
        isAuthenticating: state.auth.isAuthenticating,
        userDetails: state.user.detail,
        isLoading: state.user.loadingUser,
        userId: state.auth.userId,
        userName: state.user.userName,
        userEmail: state.user.userEmail,
        userPhone: state.user.userPhone,
        userTIN: state.user.userTIN,
        userRoles: state.user.userRoles
    };
}

const paperStyle = {
    marginTop: -50,
    paddingBottom: 50,
    paddingTop: 25,
    padding: 20,
    width: '100%',
    textAlign: 'left',
    display: 'inline-block',
};


const isToday = (someDate) => {
    const today = new Date()
    return someDate.getDate() == today.getDate() &&
        someDate.getMonth() == today.getMonth() &&
        someDate.getFullYear() == today.getFullYear()
}

const customStyles = {
    top: `10%`,
    margin: 'auto',
    width: 400,
    height: 400,
    background: 'rgba(r, g, b, a)',
    content: {
        top: '30%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};



const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
};

const percentageLimit = (val) => {
    if (val === 0) {
        val = 1
    } else if (val > 1000) {
        val = 1000
    } else if (val < -1000) {
        val = -1000
    }
    return val
}

function PercentageFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (

        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: percentageLimit(values.value),
                    },
                });
            }}
            decimalScale={2}
            allowNegative={true}
            thousandSeparator={'.'}
            decimalSeparator={','}
            suffix="%"
        />
    );
}

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (

        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
            decimalScale={2}
            allowNegative={false}
            thousandSeparator={'.'}
            decimalSeparator={','}
            prefix="$"
        />
    );
}

@connect(mapStateToProps, mapDispatchToProps)
export class CashBalanceView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showCloseBalanceModal: false,
            loadingLastBalance: false,
            createMovement: true,
            showCashBalance: false,
            isLoading: true,
            cashBalanceDate: new Date(),
            showMsg: false,
            duration: 3000,
            msgType: 'success', // or 'error'
            msg: null,
            cashBalanceReportData: [],
            openNewCashBalance: false,
            loadingLastBalance: false,
            showModalNewBalance: false,
            initialAmount: 0,
            declaredAmount: 0,
            reason: null,
            expectedAmount: 0,
            tempAmount: 0,
            operationType: 'Egreso',
            movementAmount: 0,
            movementAmountReceived: 0,
            movementAmountReturned: 0,
            current_balance: 0,

        }
    }


    handleChange = (event) => {
        this.setState({ payMethod: event.target.value });
    }
    setAmount = (e) => {
        this.setState({ amount: parseInt(e.target.value) })
    }

    handleClose = () => {
        this.setState({ showMsg: false })
    }

    loadCashBalanceReport = () => {
        return (<div className='col-md-12'><Table>
            <TableHead>
                <TableRow>
                    <TableCell align="center"><b>Fecha</b></TableCell>
                    <TableCell align="center"><b>Motivo</b></TableCell>
                    <TableCell align="center"><b>Responsable</b></TableCell>
                    <TableCell align="right"><b>Monto</b></TableCell>
                    <TableCell align="right"><b>Monto real</b></TableCell>
                    <TableCell align="right"><b>Entregado</b></TableCell>
                    <TableCell align="right"><b>Recibido</b></TableCell>
                    <TableCell align="right"><b>Balance temporal</b></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {this.state.currentBalance.movements.map((movement) => (
                    <TableRow key={movement.id}>
                        <TableCell>{movement.created_on}</TableCell>
                        <TableCell align="center">{movement.reason}</TableCell>
                        <TableCell align="center">{movement.salesperson.username}</TableCell>
                        <TableCell align="right"><NumberFormat
                            value={movement.amount}
                            displayType={'text'}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            prefix="$"
                        /> </TableCell>
                        <TableCell align="right">
                            <NumberFormat
                                value={movement.actual_amount}
                                displayType={'text'}
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                prefix="$"
                            />
                        </TableCell>
                        <TableCell align="right"><NumberFormat
                            value={movement.amount_returned}
                            displayType={'text'}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            prefix="$"
                        /> </TableCell>
                        <TableCell align="right"><NumberFormat
                            value={movement.amount_received}
                            displayType={'text'}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            prefix="$"
                        /> </TableCell>
                        <TableCell align="right">
                            <NumberFormat
                                value={movement.temp_balance}
                                displayType={'text'}
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                prefix="$"
                            />

                        </TableCell>
                    </TableRow>


                ))}


            </TableBody>

        </Table></div>
        )
    }
    createMovement = (e) => {
        e.preventDefault()
        this.setState({ createMovement: false })
        let data = {}
        if(this.state.reason == '' || this.state.reason == null){
            this.setState({ showOpenMovementDialog: false, showModalNewBalance: false, msg: "Ingrese el motivo", msgType: 'error', showMsg: true })
                return
        }
        if (this.state.operationType == 'Egreso') {
            if (this.state.movementAmountReceived == 0 || this.state.movementAmountReceived == null) {
                this.setState({ showOpenMovementDialog: false, showModalNewBalance: false, msg: "Ingrese el monto pagado", msgType: 'error', showMsg: true })
                return
            }
            data = {
                'reason': this.state.reason, 'amount': parseFloat(this.state.movementAmount * -1),
                'amount_returned': parseFloat(this.state.movementAmountReceived * -1),
                'amount_received': parseFloat(this.state.movementAmountReturned),
                'salesperson': this.props.userId, 'withdrawal': true
            }

        } else {
            if (this.state.movementAmountReceived == 0 || this.state.movementAmountReceived == null) {
                this.setState({ showOpenMovementDialog: false, showModalNewBalance: false, msg: "Ingrese el monto recibido", msgType: 'error', showMsg: true })
                return
            }
            data = {
                'reason': this.state.reason, 'amount': parseFloat(this.state.movementAmount),
                'amount_received': parseFloat(this.state.movementAmountReceived),
                'amount_returned': parseFloat(this.state.movementAmountReturned * -1),
                'salesperson': this.props.userId, 'withdrawal': false
            }
        }
        CashBalanceApi.makeMovement(data)
            .then(response => {

                this.setState({ showOpenMovementDialog: false, showModalNewBalance:false, reason:null,  msg: "Movimiento registrado", msgType: 'success', showMsg: true })
                this.fetchBalance()
            })
            .catch(error => {
                this.setState({ showOpenMovementDialog: false, showModalNewBalance: false, msg: error.response.data.message, msgType: 'info', showMsg: true })
                console.log(error)
            })
    }
    openCashBalance = (e) => {
        CashBalanceApi.getLastBalance()
            .then(response => {
                this.setState({  expectedAmount: response.data.balance, showOpenMovementDialog: false,  loadingLastBalance: false, showModalNewBalance: true })
            })
            .catch((error) => {
                if (error.response.status == 422) {
                    this.setState({ expectedAmount:0, showOpenMovementDialog: false, loadingLastBalance: false, showModalNewBalance: false, initialAmount: 0 })
                }
            })
    }
    setNewCashBalance = (e) => {
        this.setState({ openingCashBalance: false })
        let data = { 'salesperson': this.props.userId, 'initial_balance': parseFloat(this.state.tempAmount) }
        CashBalanceApi.initNewCashBalance(data)
        .then(response => {
            this.setState({ canEdit: true, isLoading: false, openNewCashBalance: false, openingCashBalance: true, currentBalance: response.data, isLoading: false, loadingLastBalance: false, showModalNewBalance: false })
            this.loadBalance()
        })
        .catch((error) => {
            // en caso de error mostrar mensaje
            if (error.response.status == 422) {

                this.setState({ openingCashBalance: false, showModalNewBalance: false, isLoading: false, msg: error.response.data.message, msgType: 'error', showMsg: true })

            }
        })
        
    }

    closeBalance = () => {
        let data = { 'close_amount': parseFloat(this.state.closedAmount), 'salesperson': this.props.userId }
        CashBalanceApi.closeCashBalance(data)
            .then(response => {
                this.setState({ canEdit: false, showCloseBalanceModal: false, msg: "Caja cerrada", msgType: 'success', showMsg: true })
                this.fetchBalance()
            })
            .catch(error => {
                console.log(error)
                this.setState({ showCloseBalanceModal: false, msg: "Error al cerrar la caja", msgType: 'error', showMsg: true })

            })



    }
    fetchBalance = (balanceDate) => {
        if (balanceDate == '' || balanceDate == null) {
            let sarasa = this.state.cashBalanceDate.getFullYear() + '-' + (this.state.cashBalanceDate.getMonth() + 1 )+ '-' + this.state.cashBalanceDate.getDate()
            CashBalanceApi.getDateBalance(sarasa)
                .then(response => {
                    this.setState({ isLoading: false, currentBalance: response.data.result, current_balance: response.data.result.current_balance, openNewCashBalance: !response.data.result.closed, canEdit: !response.data.result.closed, loadingLastBalance: false, openNewCashBalance: false })
                })
                .catch((error) => {
                    console.log(error.response)
                    if (error.response.status != 422) {
                        this.setState({ currentBalance: null, isLoading: false, msg: "Error al recuperar caja", msgType: 'error', showMsg: true })

                    }
                    else {
                        let open = true
                        let date = new Date()
                        if(balanceDate && (balanceDate.getFullYear() != date.getFullYear() ||
                           balanceDate.getMonth() != date.getMonth() ||
                           balanceDate.getDate() != date.getDate())){
                               open = false
                           }
                        this.setState({ currentBalance: null, isLoading: false, openNewCashBalance: open, isLoading: false })
                    }

                })
        }
        else {
            let sarasa = balanceDate.getFullYear() + '-' + (balanceDate.getMonth() + 1 )+ '-' + balanceDate.getDate()
            CashBalanceApi.getDateBalance(sarasa)
                .then((response) => {
                    this.setState({ openNewCashBalance: false, isLoading: false,  currentBalance: response.data.result, canEdit: !response.data.result.closed, loadingLastBalance: false })
                })
                .catch((error) => {
                    console.log(error.response)
                    if (error.response.status != 422) {
                        this.setState({ isLoading: false, msg: "Error al recuperar caja", msgType: 'error', showMsg: true })

                    }
                    else {
                        let sarasa = error.response.data.message.split(' ').slice(-1)[0].split('-')
                        let year = parseInt(sarasa[0])
                        let month = parseInt(sarasa[1]) - 1
                        let day = parseInt(sarasa[2])
                        let date = new Date(year, month, day)
                        if (isToday(date)) {

                            this.setState({ isLoading: false, loadingLastBalance: true, openNewCashBalance: true, currentBalance: null, canEdit: false, loadingLastBalance: false })
                        }
                        else{
                            this.setState({ canEdit: false, currentBalance: null, isLoading: false, openNewCashBalance: false })
                        }
                    }

                })

        }

    }

    componentDidMount = () => {
        this.fetchBalance()
    }

    render = () => {
        return (<div>
            <div className="col-md-12" >
                <Modal style={customStyles}
                    open={this.state.showModalNewBalance}
                    onClose={(e) => { this.setState({ showModalNewBalance: !this.state.showModalNewBalance, loadingLastBalance: false }) }}
                >
                    <Paper elevation={4} style={paperStyle}>
                        <div>
                            <div className='col-md-12' style={{ marginLeft: 10, marginTop: 30 }}>
                                <Typography variant="h6" gutterBottom align='center' >
                                    Monto esperado:  <NumberFormat
                                        value={this.state.expectedAmount}
                                        displayType={'text'}
                                        thousandSeparator={'.'}
                                        decimalSeparator={','}
                                        prefix="$"
                                    />
                                </Typography>
                            </div>
                            <div className='col-md-12' style={{ marginLeft: 10, marginTop: 30 }}>
                                <Typography variant="h6" gutterBottom align='center' >
                                    Monto incial:

                                      <TextField style={{ marginTop: -10, marginLeft: 15 }}
                                        value={this.state.tempAmount}
                                        onChange={(e) => {
                                            this.setState({ tempAmount: e.target.value })

                                        }}
                                        id="amount"
                                        InputProps={{
                                            inputComponent: this.state.percentage ? PercentageFormatCustom : NumberFormatCustom,
                                        }}
                                    />
                                </Typography>
                            </div>

                            <div className='col-md-3 col-md-offset-4' style={{ marginTop: 30 }}>
                                <Button
                                    onClick={this.setNewCashBalance}
                                    variant="contained"
                                    color="primary"
                                    disabled={this.state.openingCashBalance}
                                >

                                    Abrir Caja
                                </Button>
                            </div>
                        </div>

                    </Paper>
                </Modal>
            </div>
            <div className="col-md-12" >
                <Modal style={customStyles}
                    open={this.state.showCloseBalanceModal}
                    onClose={(e) => { this.setState({ showCloseBalanceModal: !this.state.showCloseBalanceModal }) }}
                >
                    <Paper elevation={4} style={paperStyle}>
                        <div>
                            <div className='col-md-12' style={{ marginLeft: 10, marginTop: 30 }}>
                                <Typography variant="h6" gutterBottom align='center' >
                                    Balance esperado:  <NumberFormat
                                        value={this.state.current_balance}
                                        displayType={'text'}
                                        thousandSeparator={'.'}
                                        decimalSeparator={','}
                                        prefix="$"
                                    />
                                </Typography>
                            </div>
                            <div className='col-md-12' style={{ marginLeft: 10, marginTop: 30 }}>
                                <Typography variant="h6" gutterBottom align='center' >
                                    Balance obtenido:

                                      <TextField style={{ marginTop: -10, marginLeft: 15 }}
                                        autoFocus
                                        value={this.state.closedAmount}
                                        onChange={(e) => {
                                            this.setState({ closedAmount: e.target.value })

                                        }}
                                        id="amount"
                                        InputProps={{
                                            inputComponent: NumberFormatCustom,
                                        }}
                                    />
                                </Typography>
                            </div>

                            <div className='col-md-3 col-md-offset-4' style={{ marginTop: 30 }}>
                                <Button
                                    onClick={this.closeBalance}
                                    variant="contained"
                                    color="primary"
                                >

                                    Cerrar Caja
                                </Button>
                            </div>
                        </div>

                    </Paper>
                </Modal>
            </div>
            {this.state.isLoading ?
                <div style={{ marginTop: 70 }} className="col-md-6 col-md-offset-5">
                    <CircularProgress
                        size={80}
                        color='primary'
                        thickness={3}
                        style={{ display: 'center' }} />
                </div> :
                <div></div>}

            <div className='col-md-12' style={{ marginTop: 50 }}>

                <div className='col-md-12'>
                    <div className='col-md-4'>
                        <ThemeProvider theme={muitheme}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                <DatePicker
                                    inputVariant="standard"
                                    variant="dialog"
                                    format="dd/MM/yyyy"
                                    id="po_date"
                                    label="Fecha de Caja"
                                    value={this.state.cashBalanceDate}
                                    maxDate={moment().toDate()}
                                    autoOk={true}
                                    onChange={(e) => {
                                        this.setState({ cashBalanceDate: e })
                                        this.fetchBalance(e)
                                    }}
                                    // onClose={(e) =>{this.fetchBalance()}}

                                />
                            </MuiPickersUtilsProvider>
                        </ThemeProvider>
                     

                    </div>
                </div>


            </div>
            { this.state.openNewCashBalance && <div>
                <div className='col-md-3 col-md-offset-5'>
                    <Button
                        onClick={this.openCashBalance}
                        variant="contained"
                        color="primary"
                        disabled={this.state.loadingLastBalance == true}
                    >

                        Abrir Caja del dia
                    </Button>
                </div>
            </div>}
            {(this.state.currentBalance && !this.state.currentBalance.closed) &&
                <div className='col-md-12' style={{ marginTop: 20 }}>
                    <Typography variant="h6" gutterBottom align='left' >
                        <b>Monto Actual:</b>  <NumberFormat
                            value={this.state.currentBalance.current_balance}
                            displayType={'text'}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            prefix="$"
                        />
                    </Typography>
                </div>}
            {(this.state.currentBalance && this.state.currentBalance.closed) &&
                <Typography variant="subtitle1" gutterBottom align='left' >
                    <b>Iniciada Por:  </b> {this.state.currentBalance.started_by.username.toUpperCase()} - {this.state.currentBalance.created_on.split(' ')[1]}
                </Typography>}
            {(this.state.currentBalance && this.state.currentBalance.closed) &&
                <div>
                    <Typography variant="subtitle1" gutterBottom align='left' >
                        <b>Monto Inicial:</b>  <NumberFormat
                            value={this.state.currentBalance.initial_balance}
                            displayType={'text'}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            prefix="$"
                        />
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom align='left' >
                        <b>Monto esperado al inicio:</b>  <NumberFormat
                            style={{color: this.state.currentBalance.expected_init==this.state.currentBalance.initial_balance?"green" : "red"}}
                            value={this.state.currentBalance.expected_init}
                            displayType={'text'}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            prefix="$"
                        />
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom align='left' >
                        <b>Monto esperado al cierre:</b>  <NumberFormat
                            value={this.state.currentBalance.current_balance}
                            displayType={'text'}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            prefix="$"
                        />
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom align='left' >
                        <b>Monto obtenido al cierre:</b>  <NumberFormat
                            style={{color: this.state.currentBalance.closed_balance==this.state.currentBalance.current_balance?"green" : "red"}}
                            value={this.state.currentBalance.closed_balance}
                            displayType={'text'}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            prefix="$"
                        />
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom align='left' >
                        <b>Cerrado por:  </b>
                        {this.state.currentBalance.closed_by.username.toUpperCase()} - {this.state.currentBalance.closed_date.split(' ')[1]}
                    </Typography>
                </div>}

            {this.state.currentBalance && this.loadCashBalanceReport()}

            {this.state.canEdit && <div>
                <div className='col-md-2 ' style={{ marginTop: 20 }}>
                    <Button
                        onClick={this.closeCashBalance}
                        onClick={(e) => this.setState({ showCloseBalanceModal: !this.state.showCloseBalanceModal })}
                        variant="contained"
                        color="secondary"
                        disabled={this.state.loadingLastBalance}
                        style={{ align: 'right' }}
                    >

                        Cerrar Caja
                </Button>
                </div>
                <div className='col-md-2 col-md-offset-8' style={{ marginTop: 20 }}>
                    <Button
                        onClick={this.openMovement}
                        onClick={(e) => this.setState({ showOpenMovementDialog: !this.state.showOpenMovementDialog })}
                        variant="contained"
                        color="primary"
                        disabled={this.state.loadingLastBalance}
                        style={{ align: 'right' }}
                    >

                        Registrar movimiento
                </Button></div></div>}

            <div className="col-md-12" >
                <Modal style={customStyles}
                    open={this.state.showOpenMovementDialog}
                    onClose={(e) => { this.setState({ showOpenMovementDialog: !this.state.showOpenMovementDialog }) }}
                >
                    <Paper elevation={4} style={paperStyle}>
                        <div>
                            <div className='col-md-8 -col-md-offset-4' style={{ marginLeft: 80, marginTop: 30 }}>
                                <Typography variant="h6" gutterBottom align='left' >
                                    <b>Tipo de operacion</b>
                                </Typography>
                                <FormControl component="fieldset">
                                    <RadioGroup aria-label="position" name="position"
                                        value={this.state.operationType}
                                        onChange={(e) => this.setState({ operationType: e.target.value })} row>
                                        <FormControlLabel
                                            value="Egreso"
                                            name="operationType"
                                            control={<Radio color="primary" size="small" />}
                                            label="Egreso"
                                            labelPlacement="top"
                                        />
                                        <FormControlLabel
                                            value="Ingreso"
                                            name="operationType"
                                            control={<Radio color="primary" size="small" />}
                                            label="Ingreso"
                                            labelPlacement="top"
                                        />


                                    </RadioGroup>


                                </FormControl>

                            </div>
                            <div className='col-md-12' style={{ marginLeft: 10, marginTop: 10 }}>
                                <div className='col-md-7'>

                                    <Typography variant="subtitle2" gutterBottom align='center' >
                                        Monto de la operacion:
                                    </Typography>
                                </div>
                                <div className='col-md-4' >
                                    <TextField style={{ marginTop: -20, marginLeft: -15 }}
                                        autoFocus
                                        value={this.state.movementAmount}
                                        onChange={(e) => {
                                            this.setState({ movementAmount: e.target.value })

                                        }}
                                        id="amount"
                                        InputProps={{
                                            inputComponent: NumberFormatCustom,
                                        }}

                                    />
                                </div>
                            </div>
                            <div className='col-md-12' style={{ marginLeft: 10, marginTop: 10 }}>
                                <div className='col-md-7'>

                                    <Typography variant="subtitle2" gutterBottom align='center' >
                                        {this.state.operationType == 'Ingreso' ? 'Monto Recibido' : 'Monto pagado'}
                                    </Typography>
                                </div>
                                <div className='col-md-4' >
                                    <TextField style={{ marginTop: -20, marginLeft: -15 }}
                                        value={this.state.movementAmountReceived}
                                        onChange={(e) => {
                                            this.setState({ movementAmountReceived: e.target.value })

                                        }}
                                        id="amount"
                                        InputProps={{
                                            inputComponent: NumberFormatCustom,
                                        }}
                                        autoFocus="autofocus"
                                    />
                                </div>
                            </div>
                            <div className='col-md-12' style={{ marginLeft: 10, marginTop: 10 }}>
                                <div className='col-md-7'>

                                    <Typography variant="subtitle2" gutterBottom align='center' >
                                        {this.state.operationType == 'Ingreso' ? 'Vuelto otorgado' : 'Vuelto recibido'}
                                    </Typography>
                                </div>
                                <div className='col-md-4' >
                                    <TextField style={{ marginTop: -20, marginLeft: -15 }}
                                        value={this.state.movementAmountReturned}
                                        onChange={(e) => {
                                            this.setState({ movementAmountReturned: e.target.value })

                                        }}
                                        id="amount"
                                        InputProps={{
                                            inputComponent: NumberFormatCustom,
                                        }}
                                        autoFocus="autofocus"
                                    />
                                </div>
                            </div>
                            <div className='col-md-12' style={{ marginLeft: 10, marginTop: 10 }}>
                                <div className='col-md-3'>

                                    <Typography variant="subtitle2" gutterBottom align='center' >
                                        Motivo
                                    </Typography>
                                </div>
                                <div className='col-md-7' >
                                    <TextField style={{ marginTop: -20, marginLeft: -15 }}
                                        inputProps={{ maxLength: 20 }}
                                        onChange={(e) => this.setState({ reason: e.target.value })}
                                    />
                                </div>
                            </div>
                            <div className='col-md-12' style={{ marginLeft: -5, marginTop: 20 }}>

                                <div className='col-md-4 col-md-offset-4'>
                                    <Button
                                        onClick={this.createMovement}
                                        variant="contained"
                                        color="primary"
                                    >

                                        Generar
                                </Button>
                                </div>
                            </div>
                        </div>

                    </Paper>
                </Modal>
            </div>
            <Notification
                open={this.state.showMsg}
                variant={this.state.msgType}
                message={this.state.msg}
                onClose={this.handleClose}
                duration={this.state.duration}
            />

        </div>
        )
    }

}

export default CashBalanceView;


// WEBPACK FOOTER //
// ./src/components/Billing/CashBalanceView.js